import PropTypes from 'prop-types';

const HorizontalDivider = ({ text = '' }) => {
  if (text.length === 0) {
    return <div className="mt-2 border-t-2 border-pj-gray-500 pb-4" />;
  }

  return (
    <div className="flex min-w-max items-center justify-center gap-4 ">
      <span className="grow border-t-2 border-pj-gray-500" />
      <span className="text-pj-gray-700">{text}</span>
      <span className="grow border-t-2 border-pj-gray-500" />
    </div>
  );
};

HorizontalDivider.propTypes = {
  text: PropTypes.string,
};

export default HorizontalDivider;
